module.exports = __webpack_public_path__ + "static/media/LK_Add User.7c615cf4.svg";